import { render, staticRenderFns } from "./template-edit.vue?vue&type=template&id=b267a900&scoped=true"
import script from "./template-edit.vue?vue&type=script&lang=ts"
export * from "./template-edit.vue?vue&type=script&lang=ts"
import style0 from "./template-edit.vue?vue&type=style&index=0&id=b267a900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b267a900",
  null
  
)

export default component.exports